import { useState } from 'react';
import { LoaderBar } from '../../../../../../components';
import { ToteListWarehouseHook } from '../../../../../../hooks/tote';
import { SortedToteAntTable } from '../../../../../../page-components';
import { OrderService, ToastMessage } from '../../../../../../utility';

export function ToteTab({ warehouseId }) {
  const { data, totalData, loading, filter, filterChanged, pageChanged, refresh } =
    ToteListWarehouseHook(warehouseId);
  const [processing, setProcessing] = useState(false);

  const fulfillTote = async item => {
    try {
      setProcessing(true);

      const payload = {
        toteId: item.id,
      };
      await OrderService.fulfillTote(item.orderId, payload);
      ToastMessage.success('Order marked as fulfilled Successfully');
      refresh();
    } catch (error) {
      ToastMessage.apiError(error);
    } finally {
      setProcessing(false);
    }
  };

  return (
    <div className="position-relative pt-4">
      {processing && <LoaderBar />}

      <SortedToteAntTable
        loading={loading}
        data={data || []}
        totalData={totalData}
        filter={filter}
        filterChanged={filterChanged}
        pageChanged={pageChanged}
        fulfillTote={fulfillTote}
        warehouseId={warehouseId}
      />
    </div>
  );
}
